import React from 'react'
import { Outlet, useNavigate } from 'react-router-dom'
import { useDispatch } from 'hooks/use-redux'
import ModalWindow from 'components/ui/modal-window'
import Video from 'components/ui/video'

const DiscoverMusicVideoModal = (): React.ReactNode => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  return (
    <>
      <ModalWindow
        header="Discover music on DISCO Catalogs"
        isOpen
        onClose={() => {
          navigate('/catalogs')
        }}
      >
        <Video
          width={933}
          height={524}
          src="https://www.youtube.com/embed/7k8LR1B-Hcw?autoplay=1&modestbranding=1&color=247AB7"
        />
      </ModalWindow>
      <Outlet />
    </>
  )
}

export default DiscoverMusicVideoModal
